// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__1dzq-","logo":"Menu_logo__11wpU","menu-active":"Menu_menu-active__36QIT","active":"Menu_active__1j-D7"};